import { resto as restoApi, userService, archives as archivesApi } from '@saucelabs/sl-util-axios';

export const searchV11 = (params) => (
  restoApi.get('/rest/v1.1/archives/search', { params })
);

export const fetchFacet = ({ name, params }) => (
  restoApi.get(`/rest/v1/archives/facet_search/${name}`, { params })
);

export const getTeams = ({ limit = 99999, offset = 0, ...rest } = {}) => (
  userService.get('/v1/teams/', { params: { limit, offset, ...rest } })
);

export const resto = {
  searchV11,
  fetchFacet,
};

export const archives = {
  searchV11: (params) => (
    archivesApi.get('/legacy/v1.1/search', { params })
  ),
  fetchFacet: ({ name, params }) => (
    archivesApi.get(`/legacy/facet_search/${name}`, { params })
  ),
};
